import { Modal } from 'antd';
import { ReactNode } from 'react';
import classes from './ConfirmModal.module.scss';
import cn from 'classnames';
import { getTheme } from 'helpers/getTheme';

type Props = {
  title?: string;
  loading: boolean;
  open: boolean;
  bodyContent: ReactNode;
  okText?: string;
  cancelText?: string;
  onOk?: () => void;
  onCancel?: () => void;
  onClose: () => void;
};

export default function ConfirmModal({ bodyContent, onOk, onCancel, onClose, ...props }: Props) {
  const handleCancelAndClose = (event: any) => {
    if (event.currentTarget.id === 'cancelButton') {
      onCancel && onCancel();
    } else {
      onClose();
    }
  };

  return (
    <Modal
      {...props}
      className={cn(classes.modal, getTheme())}
      cancelButtonProps={{ id: 'cancelButton', style: {display: !onCancel ? 'none' : 'inline'} }}
      okButtonProps={{ style: {display: !onOk ? 'none' : 'inline'} }}
      classNames={{ body: classes.body }}
      confirmLoading={props.loading}
      onCancel={handleCancelAndClose}
      onOk={onOk && onOk}
    >
      {bodyContent}
    </Modal>
  );
}
